import envConfig from '@/config';
// import http from './http';
import httpArea from './http/httpArea';
import axios from 'axios';

const env = envConfig.env.toUpperCase();
const publicPath = envConfig[`VUE_APP_${envConfig.env.toUpperCase()}_PUBLIC_PATH`];

console.log(publicPath);

// 获取本机国家地区
export const getLocationAreaApi = async (params, config = {}) => {
  const headers = { Authorization: `APPCODE 7f404318595e45328551e3e0887c866a` };
  const resIp = await axios.get('https://jsonip.com', { params, ...config });
  const ip = resIp.data.ip;
  const params2 = { ip };
  const res = await axios.get('https://ipcity.market.alicloudapi.com/ip/city/query', { params: params2, headers, ...config });
  return res.data;
};

// // 国家地区
// export const getLoginAreaApi = (params, config = {}) => http.get('/fuel-user/serveruser/app/auth/user/getLoginArea', { params, headers: { 'Cache-Control': 'public' }, ...config });
// 国家地区
export const getLoginAreaApi = async (params, config = {}) => {
  if (env === 'TEST') {
    const res = await axios.get(`${publicPath}localData/getLoginAreaTest.json`, { params, headers: { 'Cache-Control': 'public' }, ...config });
    return res.data;
  }
  const res = await axios.get(`${publicPath}localData/getLoginArea.json`, { params, headers: { 'Cache-Control': 'public' }, ...config });
  return res.data;
};

/**
 * 埋点
 * @param {Object} params
 * @param {Object} config
 * @returns
 */
export const appDbpointSendApi = (params, config = {}) => httpArea.post('/fuel-user/serveruser/app/dbpoint/send', params, { ...config });

// 用户车辆列表
export const vehicleOptionApi = (params, config = {}) => httpArea.get('/fuel-vehicle/servervehicle/app/vehicle/option', { params, ...config });

// export const siteLoggerApi = (params, config = {}) => http.get('', { params, ...config });
export const siteLoggerApi = () => {};

// 滑块验证码
export const commonCodeGenrateApi = (params, config = {}) => httpArea.post('/fuel-user/serveruser/common/code/generate', params, { ...config });
// 滑块验证码校验
export const commonCodeSendCodeV2Api = (params, config = {}) => httpArea.post('/fuel-user/serveruser/common/code/send_code_v2', params, { ...config });

// oss文件上传临时签名
export const ossStsApi = async (params, config = {}) => {
  const resData = await httpArea.get('/fuel-user/serveruser/sys/oss/sts', { params, ...config });
  const data = resData.data || {};
  return {
    accessKeyId: data.accessKeyId,
    accessKeySecret: data.accessKeySecret,
    endpoint: data.httpsEndPoint,
    bucket: data.bucket,
    stsToken: data.securityToken,
  };
};
